import { useDispatch, useSelector } from "react-redux";
import { CurrentUserState, updateProfile } from "../redux/current-user-slice";
import { AppState } from "../redux/store";
import { UserProfile } from "@nt-portal/server-sdk";

/**
 * Selects the current authenticated user object from the global store.
 * @returns The current user or undefined when not signed in.
 */
export function useCurrentUser() {

    const _currentUserState = useSelector<AppState>(state => state.currentUser) as CurrentUserState;
    return _currentUserState.user
}


/**
 * Provides the active user's role assignments from redux state.
 * @returns Array of role identifiers granted to the user.
 */
export function useUserRoles() {

    const _currentUserState = useSelector<AppState>(state => state.currentUser) as CurrentUserState;
    return _currentUserState.roles;
}



/**
 * Reads the full permission map granted to the current user.
 * @returns Permission lookup keyed by module id.
 */
export function useUserPermissions() {
    const _currentUserState = useSelector<AppState>(state => state.currentUser) as CurrentUserState;
    return _currentUserState.permissions;
}


